<script>
  export default {
    name: 'ZmRow',

    componentName: 'ZmRow',

    props: {
      tag: {
        type: String,
        default: 'div'
      },
      gutter: Number,
      type: String,
      justify: {
        type: String,
        default: 'start'
      },
      align: {
        type: String,
        default: 'top'
      }
    },

    provide() {
      return {
        row: this
      };
    },

    computed: {
      style() {
        const ret = {};

        if (this.gutter) {
          ret.marginLeft = `-${this.gutter / 2}px`;
          ret.marginRight = ret.marginLeft;
        }

        return ret;
      },
      classList() {
        const classList = ['zm-row'];
        const justify = this.justify;
        const align = this.align;
        if (justify !== 'start') {
          classList.push(`is-justify-${justify}`);
        }
        if (align !== 'top') {
          classList.push(`is-align-${align}`);
        }
        classList.push({
          'zm-row--flex': this.type === 'flex'
        });
        return classList;
      }
    },

    render(h) {
      return h(this.tag, {
        class: this.classList,
        style: this.style
      }, this.$slots.default);
    }
  };
</script>

<style lang="scss">
  @import "../../scss/mixins/mixins";
  @import "../../scss/mixins/utils";
  @import "../../scss/common/var";

  @include b(row) {
    position: relative;
    box-sizing: border-box;
    @include utils-clearfix;

    @include m(flex) {
      display: flex;
      &:before,
      &:after {
        display: none;
      }

      @include when(justify-center) {
        justify-content: center;
      }
      @include when(justify-end) {
        justify-content: flex-end;
      }
      @include when(justify-space-between) {
        justify-content: space-between;
      }
      @include when(justify-space-around) {
        justify-content: space-around;
      }

      @include when(align-middle) {
        align-items: center;
      }
      @include when(align-bottom) {
        align-items: flex-end;
      }
    }
  }
</style>
